import MaintenanceFeeCollected from './MaintenanceFeeCollected.vue'
export default MaintenanceFeeCollected


// WEBPACK FOOTER //
// ./src/pages/MaintenanceFeeCollected/index.js